import React, { useState, useEffect } from "react";
import Approved from "../../../../../assets/images/approved.png";
import axios from "axios";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import AllModuleData from "../../../../Reuseable/AllModuleData";
import LoaderPost from "../../../../Reuseable/LoaderPost";

const LearningSessionLive = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [buffer, setBuffer] = useState(true);

  // Fetch Approved learning_session
  useEffect(() => {
    axios.get(`/api/admin/learning_session/live`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Live Learning Session"
        image={Approved}
        count={count}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar-admin/learning-session/details`}
        />
      )}
    </>
  );
};

export default LearningSessionLive;
